import { useQuery } from 'react-query'
import { isEmpty } from '../../utils/stringUtils'
import { ProblemDetails } from '../errors'
import { getAddresses, getContracts, getStreets } from './services'
import { ApiAddress, ApiContracts } from './types'

export const QUERYKEY_CONTRACTS = 'contracts'
export function useContractsQuery() {
    return useQuery<ApiContracts[], ProblemDetails>(QUERYKEY_CONTRACTS, () => getContracts(), {
        retry: false,
    })
}

export const QUERYKEY_ADDRESSES = 'addresses'
export function useAddressesQuery(search?: string) {
    return useQuery<ApiAddress[], ProblemDetails>([QUERYKEY_ADDRESSES, search], () => getAddresses(search), {
        enabled: search !== undefined && search.length > 0,
    })
}

export const QUERYKEY_STREETS = 'streets'
export function useStreetsQuery(search?: string, city?: string, zip?: string) {
    return useQuery<string[], ProblemDetails>([QUERYKEY_STREETS, search, city, zip], () => getStreets(search, city, zip), {
        enabled: !isEmpty(search) && !isEmpty(city) && !isEmpty(zip),
    })
}
